import React from 'react';
import './AboutSection.css';
import { IoCheckmarkDoneOutline } from "react-icons/io5";


const AboutSection = () => {
  return (
    <section className="section about" id="about" aria-label="about">
      <div className="container">

        <figure className="about-banner">
          <div className="img-holder" style={{ '--width': 520, '--height': 370 }}>
            <img 
              src="./logovin2.jpg" 
              width="520" 
              height="370" 
              loading="lazy" 
              alt="about banner" 
              className="img-cover" 
            />
          </div>


          
        </figure>

        <div className="about-content">
          <p className="section-subtitle">About Us</p>

          <h2 className="h2 section-title">
            Just a small team <span className="span">Making your college life easy</span> With all the subjects covered!
          </h2>

          <p className="section-text">
            We are your fellow college mates helping you to succeed and do well in your exam with minimum efforts!
            Hope you enjoy this and do provide us with your feedback!!
          </p>
          <ul className="about-list">
  <li className="about-item">
    <IoCheckmarkDoneOutline style={{ color: "#FFD700" }} aria-hidden="true" />
    <span className="span">Easy and Accurate resources!</span>
  </li>
  <li className="about-item">
    <IoCheckmarkDoneOutline style={{ color: "#FFD700" }} aria-hidden="true" />
    <span className="span">Online Remote Learning</span>
  </li>
  <li className="about-item">
    <IoCheckmarkDoneOutline style={{ color: "#FFD700" }} aria-hidden="true" />
    <span className="span">Absolutely Free!</span>
  </li>
</ul>

        </div>

      </div>
    </section>
  );
};

export default AboutSection;
